module.exports = __webpack_public_path__ + "img/prod-mkey-qrcode.747e381c.png";